import { render } from "./LabeledInputReports.vue?vue&type=template&id=00181f31"
import script from "./LabeledInputReports.vue?vue&type=script&lang=js"
export * from "./LabeledInputReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__